import { combineReducers } from 'redux';

import { IEntityActions } from '../../../../../data/store';
import { Actions as ContractActions, ActionTypes as ContractActionTypes } from '../../../../../entities/contracts/actions';
import { IContracts } from '../../../../../entities/contracts/types';
import { Actions as ViewActions, ActionTypes as ViewActionTypes } from './actions';

export const loadingCustomer = (state = false, action: IEntityActions = {} as any) => {
	switch (action.type) {
		case 'CUSTOMER_GET_BY_ID_REQUEST':
			return true;
		case 'CUSTOMER_GET_BY_ID_RECEIVE':
		case 'CUSTOMER_GET_BY_ID_FAILURE':
			return false;
		default:
			return state;
	}
};

export const loadingContracts = (state = false, action: ContractActions = {} as any) => {
	switch (action.type) {
		case ContractActionTypes.CUSTOMER_CONTRACTS_REQUEST:
			return true;
		case ContractActionTypes.CUSTOMER_CONTRACTS_RECEIVE:
		case ContractActionTypes.CUSTOMER_CONTRACTS_FAILURE:
			return false;
		default:
			return state;
	}
};

export const customerChannelSelection = (state: { [customerId: string]: IContracts } = {}, action: ContractActions = {} as any) => {
	switch (action.type) {
		case ContractActionTypes.CUSTOMER_CONTRACTS_RECEIVE:
		case ContractActionTypes.UPDATE_CONTRACTS_RECEIVE:
			return { ...state, [action.payload.id]: action.payload.contracts };
		default:
			return state;
	}
};

export const saving = (state = false, action: ViewActions = {} as any) => {
	switch (action.type) {
		case ViewActionTypes.ADMIN_CUSTOMER_UPDATE_DETAILS_REQUEST:
			return true;
		case ViewActionTypes.ADMIN_CUSTOMER_UPDATE_DETAILS_RECEIVE:
		case ViewActionTypes.ADMIN_CUSTOMER_UPDATE_DETAILS_FAILURE:
			return false;
		default:
			return state;
	}
};

export const validating = (state = false, action: IEntityActions = {} as any) => {
	switch (action.type) {
		case 'CUSTOMER_VALIDATE_REQUEST':
			return true;
		case 'CUSTOMER_VALIDATE_RECEIVE':
		case 'CUSTOMER_VALIDATE_FAILURE':
			return false;
		default:
			return state;
	}
};

export interface IAdminCustomerEditPageState {
	loadingCustomer: ReturnType<typeof loadingCustomer>;
	loadingContracts: ReturnType<typeof loadingContracts>;
	customerChannelSelection: ReturnType<typeof customerChannelSelection>;
	saving: ReturnType<typeof saving>;
	validating: ReturnType<typeof validating>;
}

export default combineReducers<IAdminCustomerEditPageState>({
	loadingCustomer,
	loadingContracts,
	customerChannelSelection,
	saving,
	validating
});
